export const contactFactory = {
	contactFactory: {
		title: "Contact Factory",
		subTitle: "Use from below to submit your part question to the Service department.",
		serviceText: "For other service-related inquiries, please call",
		accountNumber: "Account Number",
		companyName: "Company Name",
		address: "Address",
		firstName: {
			label: "First Name",
			placeholder: "Enter First Name",
		},
		lastName: {
			label: "Last Name",
			placeholder: "Enter Last Name",
		},
		email: {
			label: "Email",
			placeholder: "Enter Email",
		},
		daytimePhone: {
			label: "Daytime Phone",
			placeholder: "Enter Phone",
		},
		subject: "Subject",
		itemNumber: "Item Number",
		itemDescription: "Item Description",
		modelNumber: {
			label: "Model Number",
			placeholder: "Enter Model Number",
		},
		serialNumber: {
			label: "Serial Number",
			placeholder: "Enter Serial Number",
		},
		comments: {
			label: "Questions/ Comments",
			placeholder: ""
		},
		cancel: "Cancel",
		send: "Send",
		stay: "Stay",
		leave: "Leave",
	}
};